import React from 'react';
import Container from '@mui/material/Container';
import LogoComponent from "./LogoComponent";

function HeaderSmallComponent() {
    return (
        <div className="header header-xs">
            <Container maxWidth="lg">

                <LogoComponent />

            </Container>
        </div>
    );
}

export default HeaderSmallComponent;
